import { NotifSubjectsType, NotificationSubject } from 'API/Home/userUpdates';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import {
  Documents,
  Notes,
  OrderMedications,
  RecognitionStatusIcon,
  RefreshIcon,
  ReqApproved,
  Statoscope,
  equipmentIcon1,
} from 'Images';

export const getUpdateGeneralDataByTypeId = (
  typeId: number,
  applyNumber?: string,
  notifSubjectId?: number,
  prescCode?: number,
  requestNumber?: string
) => {
  let label = '',
    url = '',
    iconImg = '',
    secondLinkLabel = '',
    secondLinkUrl = '';

  const dictionary = Dictionary[DICTIONARY.Home].userUpdates;

  switch (typeId) {
    case NotifSubjectsType.MedicalReferrals:
      label = dictionary.allMedicalReferrals;
      url = '/medical-referrals';
      iconImg = Statoscope;
      break;
    case NotifSubjectsType.Documents:
      label = dictionary.allDocuments;
      url = '/documents';
      iconImg = Documents;
      break;
    case NotifSubjectsType.PaymentsAndDeductions:
      label = dictionary.allPaymentAndDeductions;
      url = '/payments&deductions';
      iconImg = RefreshIcon;
      break;
    case NotifSubjectsType.Applies:
      label = dictionary.applyStatus;
      url = applyNumber ? `/applies/${applyNumber}` : '/applies';
      iconImg = Notes;
      break;
    case NotifSubjectsType.RecognitionStatus: {
      if (
        notifSubjectId &&
        (notifSubjectId === NotificationSubject.RecogStatus_Ended_Single ||
          notifSubjectId === NotificationSubject.RecogStatus_Ended_Group)
      ) {
        label = dictionary.digitalFolder;
        url = '/documents';
        iconImg = ReqApproved;
      } else {
        label = dictionary.applyStatus;
        url = applyNumber
          ? `/recognitionStatus/${applyNumber}`
          : '/recognitionStatus';
        iconImg = RecognitionStatusIcon;
      }
      break;
    }
    case NotifSubjectsType.Prescriptions: {
      label = dictionary.allMedicationOrders;
      url = prescCode ? `/medicine/${prescCode}` : '/medicine';
      iconImg = OrderMedications;
      if (notifSubjectId) {
        if (
          notifSubjectId ===
          NotificationSubject.PrescriptionStatus_SuperpharmPartialSupply
        ) {
          label = dictionary.medicineOrderList;
        }
      }
      break;
    }
    case NotifSubjectsType.Medications: {
      label = dictionary.allMedicationOrders;
      url = '/medicine';
      iconImg = OrderMedications;
      break;
    }
    case NotifSubjectsType.ConsumEquipOrders: {
      iconImg = equipmentIcon1;
      if (notifSubjectId && requestNumber) {
        label = dictionary.equipmentOrder;
        url = `/equipment/${requestNumber}`;
      } else {
        label = dictionary.equipment;
        url = '/equipment';
      }
    }
  }

  return { label, url, iconImg, secondLinkUrl, secondLinkLabel };
};

export const shouldPopup = (jsonData: any, notifEntityId: number): boolean => {
  return (
    jsonData &&
    jsonData?.Title !== null &&
    jsonData.Items.length > 1 &&
    notifEntityId === NotifSubjectsType.MedicalReferrals
  );
};

export const isDownload = (jsonData: any, notifEntityId: number): boolean => {
  return (
    jsonData?.Title === null &&
    jsonData?.Items[0].Id &&
    (notifEntityId === NotifSubjectsType.MedicalReferrals ||
      notifEntityId === NotifSubjectsType.Documents)
  );
};

export const shouldHaveTwoLinks = (id: number): boolean => {
  const arr = [-1]; // look at updates table. -1 is temp example
  return arr.includes(id);
};
